<div class="breadcrumbs">
    <h3>
    <a *ngIf="breadLinks.firstLink.name" class="first-link" (click)="resetStorage()" routerLink="{{breadLinks.firstLink.link}}">{{breadLinks.firstLink.name}}</a>
    <span *ngIf="breadLinks.secondLink.name" > > </span>
    <a *ngIf="breadLinks.secondLink.name" class="second-link" routerLink="{{breadLinks.secondLink.link}}">{{breadLinks.secondLink.name}}</a>
    <span *ngIf="breadLinks.thirdLink.name" > > </span>
    <span class="thirdLink" *ngIf="breadLinks.thirdLink.name" ><strong>{{breadLinks.thirdLink.name}}</strong></span>
</h3>
</div>
